<template>
    <span class="form-radio">
        <label>
            <input type="radio" @change="selectInput" :checked="checked" :name="name" :value="valueOn" v-bind="{...$attrs, ...ariaValidationAttributes}" :id="_id" />
            <span aria-hidden="true" class="portuna-radio-button" :class="{checked}">
                <span class="portuna-radio-button-outer"></span>
                <span class="portuna-radio-button-inner"></span>
            </span>
            <span v-if="label" v-html="label"/>
            <span v-else class="hidden">Auswahl Option</span>
        </label>
    </span>
</template>

<script setup lang="ts">
    import {useFormInput} from '@/composables/formInput';
    import {usePortuna} from '@/composables/portuna';
    import {FormRowKey} from '@/library/form';
    import {computed, inject, ref, toRefs} from 'vue';

    const portuna = usePortuna();

    const emit = defineEmits<{
        (eventName: 'update:modelValue', modelValue: Optional<InputValueType>): void;
    }>();

    const props       = withDefaults(
        defineProps<{
            id?: string;
            name?: string;
            required?: boolean;
            overwriteRequired?: boolean;
            errorName?: string;
            filterName?: string;
            type?: string;
            modelValue: InputValueType;
            context?: Record<string, any>;
            size?: string;
            events?: object;
            autofocus?: boolean;
            valueOn: boolean | number | string;
            label?: string;
        }>(),
        {
            context: () => ({}),
            events: () => ({}),
            required: false,
            overwriteRequired: false,
            errorName: '',
            filterName: '',
            type: 'text',
            size: 'long',
            autofocus: false,
        },
    );

    const parentFormRow = inject<Nullable<IFormRowContext>>(FormRowKey, null);

    const inputRef = ref<HTMLInputElement>();

    const {
              id,
              name,
              required,
              overwriteRequired,
              errorName,
              filterName,
              modelValue,
              context,
              size,
          } = toRefs(props);

    const checked     = computed(() =>
    {
        return props.modelValue === props.valueOn;
    });

    const updateValue = () =>
    {
        if (!checked.value)
        {
            return Promise.resolve();
        }

        return validateValue(
            props.valueOn,
        );
    };

    const {
              expose,
              _id,
              validateValue,
              ariaValidationAttributes,
          } = useFormInput(
        parentFormRow,
        id,
        required,
        overwriteRequired,
        errorName,
        filterName,
        size,
        modelValue,
        context,
        inputRef,
        emit,
        {
            updateValue,
        }
    );

    const selectInput = () =>
    {
        emit('update:modelValue', props.valueOn);
    };

    defineExpose(Object.assign({}, portuna, expose, {
        componentName: 'FormInputRadio',
    }));
</script>